import { render, staticRenderFns } from "./Forbbiden.vue?vue&type=template&id=8b5a2318&"
import script from "./Forbbiden.vue?vue&type=script&lang=js&"
export * from "./Forbbiden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports